// Libraries
import React from "react";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
// Component
import Page from "../Page";
import { mtUserUrl } from "../config";
import * as Storage from "../Authentication/Storage";
import * as api from "../Authentication/api";

class ConnectLink extends Page {
	state = {
		redirectToReferrer: false,
		token: "",
		authenticate: false,
		errorMessage: "",
		authenticationError: false,
		authorities: []
	};

	// http://localhost:3000/connexion/0c22619523215597d78ab4e2f0ed257f71d4a9780de0612e8bada3d755142b17

	componentDidMount() {
		super.componentDidMount();
		//this.setState({ token: this.props.match.params.token });

		fetch(`${mtUserUrl}/public/authByToken/${this.props.match.params.token}`, {
			...api.defaultParams,
			method: "GET"
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Error: " + response.status);
					return;
				}
				response.json().then(data => {
					const valeurs = JSON.stringify(data.data);

					if (data !== "null") {
						console.log(data);
						// localStorage.setItem("user", valeurs);
						Storage.setUserJson(valeurs);
						var authorities = new Array();
						data.data.authorities.forEach(function(authority) {
							authorities.push(authority.name);
						});

						this.setState(
							{
								nom: data.data.lastname,
								prenom: data.data.firstname,
								email: data.data.email,
								authenticate: true,
								redirectToReferrer: true,
								authorities: authorities
							},
							() => {
								Storage.setAuthoritiesJson(
									JSON.stringify(this.state.authorities)
								);
							}
						);
					} else {
						this.setState({
							errorMessage: "Le lien est incorrect ou expiré !",
							authenticationError: true
						});
					}
				});
			})
			.catch(err => {
				console.log(err);
			});
	}

	constructor(props) {
		super(props);
	}

	render() {
		const { t } = this.props;
		let { from } = this.props.location.state || { from: { pathname: "/" } };
		if (this.state.redirectToReferrer) return <Redirect to={from} />;
		return (
			<div className="container">
				{this.state.authenticationError && (
					<h2 className="text-center pt-5 pb-5">{this.state.errorMessage}</h2>
				)}
				{this.state.authenticate && (
					<>
						<h2 className="text-center pt-5">Activation du compte</h2>
						<h6 className="text-center pb-5">
							{this.state.prenom} | {this.state.nom} | {this.state.email}
						</h6>
					</>
				)}
			</div>
		);
	}
}

export default withTranslation()(ConnectLink);
